

































import Vue from "vue";
import _ from "lodash";
import { searchPlace } from "@/shared/utils";
import ILocation from "@/types/location";

export default Vue.extend({
  data() {
    return {
      locations: [] as ILocation[],
      location: {} as ILocation,
      debouncedSearchLocationFn: _.debounce(async function(query: string): Promise<void> {
        const places: google.maps.places.PlaceResult[] = await searchPlace(query);

        // @ts-ignore
        this.locations = places.reduce((locations: ILocation[], place: google.maps.places.PlaceResult) => {
          if (place.formatted_address && place.geometry) {
            return [...locations, {
              name: place.name,
              address: place.formatted_address,
              latitude: place.geometry.location.lat(),
              longitude: place.geometry.location.lng(),
            }];
          }
          return locations;
        }, []);
      }, 1000),
    };
  },
  methods: {
    toggleLocationSearch(): void {
      this.$store.dispatch("toggleLocationSearch");
    },
    async searchLocation(event: Event): Promise<void> {
      const input: HTMLInputElement = event.currentTarget as HTMLInputElement;

      if (input.value.trim().length >= 3) {
        try {
          await this.debouncedSearchLocationFn(input.value.trim());
        } catch (error) {
          console.error(error);
        }
      }
    },
    selectLocation(event: Event): void {
      const div: HTMLDivElement = event.currentTarget as HTMLDivElement;
      const index: number = div.dataset.index as unknown as number;
      this.$emit("select-location", this.locations[index]);
      this.$store.dispatch("toggleLocationSearch");
    },
  },
});
